import { generateRequest } from './request.js';
import { AveRequestEvents } from '../events.js';
export function generateGetStatesRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEGetStates });
}
//# sourceMappingURL=state.js.map